<script>
const numberRegex = /[0-9]+/;

export default {
  props: {
    expression: { type: String, required: true }
  },

  data() {
    return {
      result: 0,
      error: undefined,
    }
  },

  watch: {
    expression: {
      handler(to) {
        this.error = undefined

        if (!to) {
          this.result = 0
          return
        }

        let result = 0

        const parts = to.split('+')
        for (let i = 0; i < parts.length; i++) {
          const part = parts[i].trim()
          if (!part) continue

          if (!numberRegex.test(part)) {
            this.error = `'${part}' contains invalid characters, only numbers and + symbols allowed`
            return
          }

          result += Number(part)
        }

        this.result = result
      },
      immediate: true,
    },

    result: {
      handler(to) {
        this.$emit('result', to)
      },
      immediate: true,
    },
  },

  render() {
    if (!this.$scopedSlots.default) {
      return null
    }

    return this.$scopedSlots.default({
      error: this.error,
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExpressionCalculator.vue